export default __webpack_public_path__ + "navigation-guides-turn-by-turn-ui-trip-progress-960-73d00f5d270d35be04640c1b589a59b8.webp";